// extracted by mini-css-extract-plugin
module.exports = {"TitleContainer":"ConferenceTitle_TitleContainer__qMY2h","TitleContainerWithTips":"ConferenceTitle_TitleContainerWithTips__CvJr_"};